import React from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import PropTypes from 'prop-types'

const successfulColumns = [
  { field: 'catalog_id', headerName: 'Catalog ID', width: 220 },
  { field: 'currency', headerName: 'Currency', width: 120 },
  { field: 'unit_amount', headerName: 'Unit Amount', width: 150 },
  { field: 'list_price', headerName: 'List Price', width: 150 },
  { field: 'interval', headerName: 'Interval', width: 120 }
]

const failedColumns = [
  { field: 'catalog_id', headerName: 'Catalog ID', width: 220 },
  { field: 'currency', headerName: 'Currency', width: 120 },
  { field: 'unit_amount', headerName: 'Unit Amount', width: 150 },
  { field: 'list_price', headerName: 'List Price', width: 150 },
  { field: 'interval', headerName: 'Interval', width: 120 },
  { field: 'error', headerName: 'Error Reason', flex: 1, minWidth: 200 }
]

const UploadPriceResponseDialog = ({ open, onClose, responseData }) => {
  if (!responseData || !responseData.data) {
    return null
  }

  const { successfulInsertions, failedInsertions } = responseData.data
  const successRows = (successfulInsertions || []).map((item, index) => ({
    id: index,
    catalog_id: item.catalog_id || item.CatalogID || '',
    currency: item.currency || item.Currency || '',
    unit_amount: item.unit_amount || item.UnitAmount || '',
    list_price: item.list_price || item.ListPrice || item.list_amount || '',
    interval: item.interval || item.Interval || ''
  }))

  const failedRows = (failedInsertions || []).map((item, index) => {
    const row = item.row || item.data || item
    return {
      id: index,
      catalog_id: row.catalog_id || row.CatalogID || '',
      currency: row.currency || row.Currency || '',
      unit_amount: row.unit_amount || row.UnitAmount || '',
      list_price: row.list_price || row.ListPrice || row.list_amount || '',
      interval: row.interval || row.Interval || '',
      error: item.error || row.error || 'Unknown error'
    }
  })

  return (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
      <DialogTitle>CSV Upload Summary</DialogTitle>
      <DialogContent dividers>
        <Box mb={4}>
          <Typography variant='h6' gutterBottom color='success.main'>
            Successful Records ({successRows.length})
          </Typography>
          {successRows.length > 0 ? (
            <div style={{ height: 300, width: '100%' }}>
              <DataGrid
                rows={successRows}
                columns={successfulColumns}
                pageSize={5}
                rowsPerPageOptions={[5]}
                getRowId={(row) => row.id}
              />
            </div>
          ) : (
            <Typography variant='body2' color='text.secondary'>
              No successful insertions.
            </Typography>
          )}
        </Box>

        <Box>
          <Typography variant='h6' gutterBottom color='error.main'>
            Failed Records ({failedRows.length})
          </Typography>
          {failedRows.length > 0 ? (
            <div style={{ height: 300, width: '100%' }}>
              <DataGrid
                rows={failedRows}
                columns={failedColumns}
                pageSize={5}
                rowsPerPageOptions={[5, 10]}
                getRowId={(row) => row.id}
              />
            </div>
          ) : (
            <Typography variant='body2' color='text.secondary'>
              No failed insertions.
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='primary' variant='contained'>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

UploadPriceResponseDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  responseData: PropTypes.shape({
    data: PropTypes.shape({
      failedInsertions: PropTypes.arrayOf(PropTypes.object),
      successfulInsertions: PropTypes.arrayOf(PropTypes.object)
    })
  })
}

export default UploadPriceResponseDialog
